module.exports = __webpack_public_path__ + "static/media/Muli-Regular.d80f1393.ttf";